import React from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import styles from "../../../../BorrowerDetails.module.css";
import Pdf from "../../../../../../../assets/PDF_file_icon 4.svg";
import { useState } from "react";
import PDFViewer from "../../../PDFViewer/PDFViewer";
import EnlargeDocModal from "../../../Modals/EnlargeDocModal";

const CoapplicantDocument = ({
  name,
  doc,
  docType,
  download,
  apiName,
  location,
  deleteDoc,
  isDisbursed,
  coapplicantDetails,
  isDownload,
  isDelete
}) => {
  const [pdfModal, setPdfModal] = useState({
    open: false,
    data: "",
  });

  console.log(coapplicantDetails, 'details');
  console.log(name, 'name');

  const [enlargeImage, setEnlargeImage] = useState(false);
  // const [imageData, setImageData] = useState({});

  const viewPdfHandler = (url) => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: true,
      data: `data:application/pdf;base64,${url}`,
    }));
  };

  const closePdfViewer = () => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: false,
      data: "",
    }));
  };
  const enlargeImageHandler = () => {
    setEnlargeImage(true);
  };

  const closeEnlargeImage = () => {
    setEnlargeImage(false);
  };
  return (
    <>
      {pdfModal.open && (
        <PDFViewer url={pdfModal.data} closeModal={closePdfViewer} />
      )}
      {enlargeImage && (
        <EnlargeDocModal
          doc={doc}
          docType={docType}
          closeModal={closeEnlargeImage}
          docName={name}
          coapplicantDetails={coapplicantDetails}
        />
      )}
      <div>
        <Accordion>
          <AccordionSummary>
            <h5>{name}</h5>
          </AccordionSummary>
          {doc && (
            <AccordionDetails>
              {docType !== "pdf" ? (
                <div className={styles.coappDocContainer}>
                  <div>
                    <img
                      draggable={false}
                      src={`data:image/${docType};base64,${doc}`}
                      alt=""
                      onClick={enlargeImageHandler}
                    />
                    {docType !== "" ? (
                      <>
                        {isDownload && (
                          <button
                            onClick={() => download(apiName, docType, name)}
                          >
                            Download
                          </button>
                        )}
                        {isDelete && (
                          !isDisbursed && (
                            <button
                              style={{ backgroundColor: "red", marginTop: "1vh" }}
                              onClick={() =>
                                deleteDoc(apiName, docType, name, location)
                              }
                            >
                              Delete
                            </button>
                          ))}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                <div className={styles.coappDocContainer}>
                  <div>
                    <section>
                      <img
                        src={Pdf}
                        alt=""
                        className={styles.docsPDF}
                        onClick={() => viewPdfHandler(doc)}
                      />
                    </section>
                      {isDownload && (
                        <button onClick={() => download(apiName, docType, name)}>
                          Download
                        </button>
                      )}
                      {isDelete && (
                        !isDisbursed && (
                          <button
                            style={{ backgroundColor: "red", marginTop: "1vh" }}
                            onClick={() =>
                              deleteDoc(apiName, docType, name, location)
                            }
                          >
                            Delete
                          </button>
                        ))}
                  </div>
                </div>
              )}
            </AccordionDetails>
          )}
        </Accordion>
      </div>
    </>
  );
};

export default CoapplicantDocument;
